import React from 'react';
import PropTypes from 'prop-types';
import CrudContext from 'react/contexts/DefaultContext';
import BaseGrid from './BaseGrid';
import BaseForm from './BaseForm';
import FormWizard from './FormWizard';

class BaseCrud extends React.Component {
  componentDidMount() {
    const { updateTitle, entity, tabName } = this.props;
    if (updateTitle && tabName) {
      updateTitle({ key: entity, title: Monet.I18n.getResourcesByKey(tabName) });
    }
  }

  render() {
    const {
      id,
      entity,
      children,
      isGrid,
      isWizard
    } = this.props;
    const isEdit = !!id;
    let CrudStage;

    if (isGrid) {
      CrudStage = BaseGrid;
    } else if (!isWizard) {
      CrudStage = BaseForm;
    } else {
      CrudStage = FormWizard;
    }

    return (
      <CrudContext.Provider value={{ entity, isEdit, isGrid }}>
        <CrudStage id={id} entity={entity} {...this.props}>
          {children}
        </CrudStage>
      </CrudContext.Provider>
    );
  }
}

BaseCrud.propTypes = {
  children: PropTypes.node.isRequired,
  entity: PropTypes.string.isRequired,
  id: PropTypes.string,
  updateMethod: PropTypes.string,
  isGrid: PropTypes.bool,
  updateTitle: PropTypes.func,
  tabName: PropTypes.string,
  isWizard: PropTypes.bool,
};

BaseCrud.defaultProps = {
  id: null,
  updateMethod: 'PUT',
  isGrid: false,
  updateTitle: null,
  tabName: '',
  isWizard: false,
};

export default BaseCrud;
